import Icon from "./IconBase.js";
const MinusCloseIcon = (props) => {
  return (
    <Icon width="16" height="16" viewBox="0 0 16 16" {...props}>
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="0.25"
          y="0.25"
          width="15.5"
          height="15.5"
          rx="3.75"
          stroke="#757575"
          strokeWidth="0.5"
        />
        <path
          d="M3.33301 8H12.6663"
          stroke="#757575"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </Icon>
  );
};
export default MinusCloseIcon;
